import { useEffect, useState } from 'react';

const useHighlightComponent = (
  initHighlighted: boolean,
  highlightDuration: number | undefined = 7000,
  transitionDuration: number | undefined = 500
) => {
  const [isHighlighted, setIsHighlighted] = useState(initHighlighted);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => setIsHighlighted(initHighlighted), [initHighlighted]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isHighlighted)
      timer = setTimeout(() => {
        setIsFading(true);
        setIsHighlighted(false);
      }, highlightDuration);
    else timer = setTimeout(() => setIsFading(false), transitionDuration);
    return () => timer && clearTimeout(timer);
  }, [isHighlighted, highlightDuration, transitionDuration]);

  return { isHighlighted, isFading };
};

export default useHighlightComponent;
